import styled from 'styled-components';

export const SectionTryDemo = styled.div`
  background: ${props => props.backgroundColor};
  padding: 82px 40px;

  .section-try-demo--container {
    display: flex;
    align-items: center;
    justify-content: space-between;
    max-width: 1200px;
    padding: 0 20px;
    margin: 0 auto;

    .section-try-demo--text-container {
      max-width: 784px;
      padding-right: 50px;
      flex: 1;

      .section-try-demo--small-title {
        font-size: 16px;
        font-weight: 900;
        line-height: 110%;
        letter-spacing: 0.05em;
        text-transform: uppercase;
        color: var(--blue-3);
      }

      .section-try-demo--title {
        font-size: 49px;
        line-height: 110%;
        letter-spacing: -0.04em;
        color: ${props => props.titleColor};
        margin-bottom: 0;
      }
    }

    .section-try-demo--button-container {
      min-width: 160px;
      text-align: right;
    }
  }

  @media (max-width: 991px) {
    .section-try-demo--container {
      .section-try-demo--text-container {
        max-width: 100%;
        padding-right: 20px;

        .section-try-demo--small-title {
          font-size: 15px;
          line-height: 20px;
        }

        .section-try-demo--title {
          font-size: 36px;
          line-height: 44px;
        }
      }

      .section-try-demo--button-container {
        button {
          font-size: 15px;
          padding: 12px 20px;
        }
      }
    }
  }

  @media (max-width: 768px) {
    padding: 52px 20px;

    .section-try-demo--container {
      flex-direction: column;

      .section-try-demo--text-container {
        max-width: 100%;
        text-align: center;
        padding: 0;

        .section-try-demo--title {
          font-size: 32px;
          line-height: 36px;
        }
      }

      .section-try-demo--button-container {
        min-width: 0;
        margin-top: 40px;

        button {
          font-size: 15px;
          padding: 8px 20px;
        }
      }
    }
  }
`;

export const FormContainer = styled.div`
  width: 45%;
  background-color: transparent;

  > div {
    color: white;
    padding-top: 0;
  }

  .section-hero--notification {
    color: white;
  }

  .signup-form--form {
    .data-layer-form {
      justify-content: space-between;

      .ant-form-item {
        &:first-child {
          width: 100%;
          margin-right: 16px;
        }
      }
    }

    .text-field-wrapper .text-field-input {
      width: 100%;
      margin-right: 0;
    }
  }

  @media (max-width: 991px) {
    > div {
      padding: 0;
    }
    margin-top: 30px;
  }

  @media (max-width: 768px) {
    width: 100%;
  }
`;
